<div [hidden]="!open">
    <!-- <rl-resize-handle [group]="'sidePanel'" class="handle handle-loaded"></rl-resize-handle> -->
    <!-- <div class="side-edit-mode-btn">
        <div class="justify-content">
            <div class="flex-start">
                <button type="button" class="btn btn-icon-only side-edit-mode-btn-close" id="close-comment-panel">
                    <span>&#x2715;</span>
                </button>
            </div>
        </div>
    </div> -->
    <ng-template rlSidePanelMainContent></ng-template>
</div>
<div class="panels-actions" [ngClass]="{'hide-right-panel' : open}">
    <div class="hide-panel">
        <button (click)="open ? hide() : show()" class="btn btn-icon-only" [ngClass]="{'btn-active' : open}" id="hide-show-side-panel" tabindex="0" data-container="body">
            <span *ngIf="open">
                <i class="fa fa-angle-double-right" attr.aria-hidden="true"></i>
            </span>
            <span *ngIf="!open">
                <i class="fa fa-angle-double-left" attr.aria-hidden="true"></i>
            </span>
        </button>
    </div>
</div>